/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Popover } from "@mui/material";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import { useSelectFieldSchema } from "cms/fields/hooks/use-select-field-schema";
import { FieldIcon } from "cms/fields/layout/field-icon";
import { useFieldZone } from "cms/fields/hooks/use-field-zone";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { isArrayNotEmpty, isTrue } from "utils/empty-exists";

const Avatar = () => {
    
    const { t } = useTranslation();
    const { field } = useCurrentDynamicField();

    const schema = useSelectFieldSchema(field?.name);
    const type = schema?.type;
    const list = schema?.list;

    const { getFieldConfig } = useFieldZone();
    const fieldConfig = getFieldConfig(type);
    const text = fieldConfig?.text;
    const help = fieldConfig?.help;
    const notes = help?.notes;
    const listText = list ? " List " : "";
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);
    
    const handlePopoverOpen = () => {
        setOpen(true);
    };
    
    const handlePopoverClose = () => {
        setOpen(false);
    };
    
    return (
        <div className='simplicity-composer-header-icon-box'>
            {/*<Tooltip title={`Click for help...`} arrow>*/}
            <div
                className="simplicity-composer-header-icon-target"
                ref={anchorRef}
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
                aria-haspopup="true"
                aria-owns={open ? "mouse-over-popover" : undefined}
            >
                <FieldIcon type={type}/>
            </div>
            {/*</Tooltip>*/}
            <Popover
                style={{ pointerEvents: "none" }}
                open={open}
                anchorEl={anchorRef.current}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
            >
                <div style={{ margin: "24px", color: "#989898", width: "350px" }}>
                    <h4 style={{ color: "#00685E" }}>{text} {listText} Field</h4>
                    {isArrayNotEmpty(notes) &&
                            <>
                                {notes.map((note, index) =>
                                    <p key={index}>{note}</p>
                                )}
                            </>
                    }
                    {isTrue(list) &&
                            <p><b>* List:</b> {t("commons.listDescription")}</p>
                    }
                </div>
            </Popover>
        </div>
    );
};

export { Avatar };
